export default __webpack_public_path__ + "static/media/Scholaris Chain.2b6043a5.jpg";